
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from "@/components/ui/separator";

const GDPR = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="container mx-auto px-4 pt-32 pb-16 max-w-4xl">
        <h1 className="text-3xl font-bold text-darkgray mb-6 font-montserrat">GDPR-information</h1>
        
        <div className="prose prose-yellow max-w-none space-y-6 text-darkgray/80 font-opensans">
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">1. Vad är GDPR?</h2>
            <p>Den allmänna dataskyddsförordningen (GDPR) är en EU-förordning som ger individer större kontroll över sina personuppgifter och hur de används av organisationer. Den trädde i kraft den 25 maj 2018 och gäller för alla organisationer som behandlar personuppgifter tillhörande EU-medborgare.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">2. Vårt åtagande</h2>
            <p>På Snabbaupphandlingar tar vi dataskydd och din integritet på allvar. Vi har implementerat omfattande åtgärder för att säkerställa att vår behandling av personuppgifter i samband med upphandlingsanalyser följer GDPR-principerna, inklusive:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Laglighet, rättvisa och öppenhet i vår hantering av upphandlingsdata</li>
              <li>Ändamålsbegränsning för de uppgifter vi samlar in om användare och upphandlingar</li>
              <li>Uppgiftsminimering så att vi endast samlar in det som behövs för våra tjänster</li>
              <li>Korrekthet i de data vi lagrar om användare och upphandlingar</li>
              <li>Lagringsminimering med tydliga rutiner för dataradering</li>
              <li>Integritet och konfidentialitet för alla upphandlingsdata</li>
              <li>Ansvarsskyldighet i vår datahantering</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">3. Personuppgiftsansvarig</h2>
            <p>Personuppgiftsansvarig för behandlingen av dina personuppgifter i samband med vår upphandlingsplattform är:</p>
            <p className="mt-2">
              Snabbaupphandlingar AB<br />
              E-post: kontakt@snabbaupphandlingar.se<br />
              Adress: Skallebackavägen 13, 32 41 Halmstad
            </p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">4. Dataskyddsombud</h2>
            <p>Vi har utsett ett dataskyddsombud som övervakar vår efterlevnad av GDPR i samband med upphandlingsanalyser. Du kan kontakta vårt dataskyddsombud på:</p>
            <p className="mt-2">
              E-post: kontakt@snabbaupphandlingar.se<br />
              Telefon: 08-123 45 67
            </p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">5. Behandling av personuppgifter</h2>
            <p>För detaljerad information om hur vi samlar in, använder och skyddar dina personuppgifter i upphandlingssammanhang, vänligen se vår <a href="/integritetspolicy" className="text-yellow-500 hover:underline">Integritetspolicy</a>.</p>
            <p>I korthet behandlar vi dina personuppgifter för att:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Tillhandahålla och förbättra våra upphandlingsanalyser</li>
              <li>Hjälpa företag förstå och effektivisera sina anbudsprocesser</li>
              <li>Kommunicera med dig angående relevanta upphandlingsmöjligheter</li>
              <li>Uppfylla våra juridiska skyldigheter inom upphandlingsområdet</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">6. Dina rättigheter enligt GDPR</h2>
            <p>Under GDPR har du följande rättigheter gällande dina personuppgifter som vi behandlar i samband med upphandlingstjänster:</p>
            
            <h3 className="text-lg font-medium text-darkgray mt-4 mb-2 font-montserrat">Rätt till tillgång</h3>
            <p>Du har rätt att begära en kopia av de personuppgifter vi har om dig och information om hur vi använder dem i upphandlingssammanhang.</p>
            
            <h3 className="text-lg font-medium text-darkgray mt-4 mb-2 font-montserrat">Rätt till rättelse</h3>
            <p>Du har rätt att begära att vi korrigerar felaktiga personuppgifter eller kompletterar ofullständiga uppgifter som påverkar din användning av vår upphandlingstjänst.</p>
            
            <h3 className="text-lg font-medium text-darkgray mt-4 mb-2 font-montserrat">Rätt till radering</h3>
            <p>Under vissa omständigheter har du rätt att begära att vi raderar dina personuppgifter från våra upphandlingssystem (också känt som "rätten att bli bortglömd").</p>
            
            <h3 className="text-lg font-medium text-darkgray mt-4 mb-2 font-montserrat">Rätt till begränsning av behandling</h3>
            <p>Du har rätt att begära att vi begränsar behandlingen av dina personuppgifter under vissa förhållanden, till exempel om du bestrider riktigheten i dem.</p>
            
            <h3 className="text-lg font-medium text-darkgray mt-4 mb-2 font-montserrat">Rätt till dataportabilitet</h3>
            <p>Du har rätt att erhålla dina personuppgifter och upphandlingsdata i ett strukturerat, allmänt använt och maskinläsbart format, och att överföra dessa uppgifter till en annan tjänsteleverantör.</p>
            
            <h3 className="text-lg font-medium text-darkgray mt-4 mb-2 font-montserrat">Rätt att göra invändningar</h3>
            <p>Du har rätt att invända mot behandling av dina personuppgifter som baseras på vårt berättigade intresse, särskilt gällande direktmarknadsföring av upphandlingstjänster.</p>
            
            <h3 className="text-lg font-medium text-darkgray mt-4 mb-2 font-montserrat">Rätt att inte bli föremål för automatiserat beslutsfattande</h3>
            <p>Du har rätt att inte bli föremål för ett beslut som enbart baseras på automatiserad behandling av dina upphandlingsdata, inklusive profilering, som har rättsliga följder för dig.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">7. Hur du utövar dina rättigheter</h2>
            <p>Du kan utöva dina rättigheter gällande upphandlingsdata genom att kontakta oss via e-post på kontakt@snabbaupphandlingar.se eller genom att skicka ett brev till vår adress.</p>
            <p>Vi kommer att svara på din begäran inom en månad från det att vi mottar den. Denna period kan förlängas med ytterligare två månader om nödvändigt, med hänsyn till komplexiteten i din begäran relaterad till upphandlingsdata.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">8. Klagomål</h2>
            <p>Om du är missnöjd med hur vi hanterar dina personuppgifter i vår upphandlingstjänst, vänligen kontakta oss först så att vi kan försöka lösa problemet. Du har också rätt att lämna in ett klagomål till Integritetsskyddsmyndigheten (IMY), som är Sveriges tillsynsmyndighet för dataskyddsfrågor.</p>
            <p className="mt-2">
              Integritetsskyddsmyndigheten<br />
              Box 8114<br />
              104 20 Stockholm<br />
              www.imy.se
            </p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">9. Dataskyddsåtgärder</h2>
            <p>Vi har implementerat lämpliga tekniska och organisatoriska åtgärder för att skydda dina personuppgifter i vår upphandlingsplattform, inklusive:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Kryptering av personuppgifter och upphandlingsdata</li>
              <li>Regelbunden testning och utvärdering av våra säkerhetsåtgärder för upphandlingssystem</li>
              <li>Begränsad åtkomst till personuppgifter med strikta behörighetsrutiner</li>
              <li>Utbildning av personal i dataskyddsfrågor specifika för upphandlingsområdet</li>
              <li>Databehandlingsavtal med alla tredjepartsleverantörer som hanterar upphandlingsdata</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">10. Uppdateringar</h2>
            <p>Vi uppdaterar regelbundet vår GDPR-information för att säkerställa att den återspeglar vår nuvarande praxis inom upphandlingsanalys och överensstämmer med gällande lagstiftning. Den senaste versionen finns alltid tillgänglig på vår webbplats.</p>
          </section>
          
          <p className="mt-8 text-sm">Senast uppdaterad: 1 juni 2024</p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default GDPR;
